import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../../services/auth.service';
import { TosterService } from '../../../../services/toster.service';
import { ProfileService } from '../../../../services/profile.service';
import { environment } from '../../../../../environments/environment';
@Component({
  selector: 'app-document-uploaded',
  imports: [FormsModule,CommonModule],
  templateUrl: './document-uploaded.component.html',
  styleUrl: './document-uploaded.component.scss'
})
export class DocumentUploadedComponent  implements OnInit {
registered_address: string = '';
requiredDocuments: any[] = [];
countryId: string = '';
fileInputs: { [key: string]: HTMLInputElement } = {};
mainUrl=environment.API_URL;
constructor(private router: Router,private authService:AuthService,private tosterService:TosterService,private profileService:ProfileService) {}
ngOnInit(): void {
  this.getDocumets();
}
getDocumets() {
  this.profileService.getDocumentsList().subscribe({
    next: (res: any) => {
      if (res.status === true) {
        if(res.data.account_status=='resubmitted'){
            localStorage.setItem('verified', res.data.account_status);

          this.router.navigate(['/syncinns-pms/dashboard'])
        }
        this.requiredDocuments = res.data.required_documents.map((doc: any) => ({
  ...doc,
  selectedFileName: '', // <-- NEW
}));
console.log("requiredDocuments", this.requiredDocuments)
        this.countryId = res.data.country;
      }
    },
    error: (errorResponse: any) => {
      this.tosterService.showError(errorResponse.error.message);
    },
  });
}
onCloseUploadDocs() {
      localStorage.setItem('verified', 'true')
  this.router.navigate(['/syncinns-pms/dashboard']);
}
  logout() {
    this.authService.logout();
  }

  submitted: boolean = false;
  uploading: boolean = false;
  uploadProgress: number = 0; 
  onPlaceSelected(place: any) {
    if (place && place.formatted_address) {
      // Update the address field with the formatted address
      this.registered_address=place.name + ', ' + place.formatted_address;
      console.log('Selected place:', place);
      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        console.log('Location coordinates:', { lat, lng });
      }
    }
  }
onFileSelected(event: Event, docId: string): void {
  const input = event.target as HTMLInputElement;
  const file = input.files?.[0];

  if (file) {
    // Allowed types
    const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg'];
    const maxSize = 5 * 1024 * 1024; // 5 MB

    if (!allowedTypes.includes(file.type)) {
      this.tosterService.showError('Only PDF and image files (jpg, jpeg, png) are allowed.');
      this.resetFileInput(input);
      return;
    }

    if (file.size > maxSize) {
      this.tosterService.showError('File size should not exceed 5 MB.');
      this.resetFileInput(input);
      return;
    }

    // Proceed if valid
    const doc = this.requiredDocuments.find(d => d.doc_id === docId);
    if (doc) {
      doc.selectedFileName = file.name;
      this.uploadDocument(docId, file);
    }
  }
}

resetFileInput(input: HTMLInputElement): void {
  input.value = '';
}

uploadDocument(docId: string, file: File): void {
  const doc = this.requiredDocuments.find(d => d.doc_id === docId);
  if (!doc) return;

  const formData = new FormData();
  formData.append('country_id', this.countryId);
  formData.append('doc_id', doc.doc_id);
  formData.append('document_name', doc.doc_name);
  formData.append('document', file);

  this.profileService.uploadDocuments(formData).subscribe({
    next: (res) => {
      this.tosterService.showSuccess(`${doc.doc_name} uploaded successfully.`);
      this.profileService.invalidateDocumentsListCache();
      this.getDocumets(); // Refresh list
    },
    error: (err) => {
      this.tosterService.showError(`Upload failed for ${doc.doc_name}.`);
    }
  });
}


}
